"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.URLS = void 0;
const EMAILS_1 = require("./EMAILS.js");
function urlBuilder(...rest) {
    return `${rest.join('/')}`;
}
const base = 'https://arovy.com';
exports.URLS = {
    CONTACT: urlBuilder(base, 'contact'),
    CUSTOMER_PACKAGE_UPGRADE: urlBuilder(base, 'customer-package-upgrade'),
    PRIVACY_POLICY: urlBuilder(base, 'privacy-policy'),
    SUPPORT_EMAIL: `mailto:${EMAILS_1.EMAILS.SUPPORT}`,
    TERMS_OF_SERVICE: urlBuilder(base, 'terms-of-service')
};
//# sourceMappingURL=URL.js.map